import SourceSliderWidget from 'SourceComponent/SliderWidget/SliderWidget.component';
import Slider from "react-slick";
import isMobile from 'Util/Mobile';
import Html from 'Component/Html';
import Image from 'Component/Image';
import Link from 'Component/Link';
import './SliderWidget.style';

export class SliderWidget extends SourceSliderWidget {

    renderSlide = (slide, i) => {
        const {
            slide_text,
            isPlaceholder,
            title: block,
            slide_text_position,
            slide_link
        } = slide;

        const isPositionThree = slide_text_position === 3; // Check if position is '3'
        const shouldWrapWithLink = isPositionThree && slide_link; // Wrap with a link if both conditions are true

        const slideContent = (
            <figure
                block="SliderWidget"
                elem="Figure"
                key={i}
                style={{
                    display: 'flex',
                    flexDirection: 'column', // Default flex direction
                    alignItems: 'center',
                }}
            >
                <Image
                    mix={{
                        block: 'SliderWidget',
                        elem: 'FigureImage',
                        mods: isPositionThree ? { isFullWidth: true } : {}, // Add a mod for a new class
                    }}
                    ratio="custom"
                    src={this.getSlideImage(slide)}
                    isPlaceholder={isPlaceholder}
                    style={isPositionThree ? { width: '100%' } : {}} // Apply width: 100% for position '3'
                />
                {!isPositionThree && ( // Hide figcaption if position is '3'
                    <figcaption
                        block="SliderWidget"
                        elem="Figcaption"
                        mix={{ block }}
                    >
                        <Html content={slide_text || ''} />
                    </figcaption>
                )}
            </figure>
        );

        if (shouldWrapWithLink) {
            // Wrap with <Link> for internal navigation
            return (
                <Link
                    to={slide_link}
                    block="SliderWidget"
                    elem="SlideLink"
                    key={i}
                    style={{ textDecoration: 'none' }}
                >
                    {slideContent}
                </Link>
            );
        }

        return slideContent;
    };


    render() {
        const { slider: { slides } } = this.props;

        const settings = {
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
        };

        return (
            <div block="SliderWidget" mods={{ isMobile: isMobile.any() }}>
                <Slider {...settings}>
                    {slides.map(this.renderSlide)}
                </Slider>
            </div>
        );
    }
}

export default SliderWidget;
